import * as Sentry from "@sentry/react";
import { useToastsContext } from "@lending/hooks/useToasts";
import { useApi } from "@lending/lib/api";

function usePatchApplicantConsentQuery() {
  const $api = useApi();
  const { showGenericErrorToast, clearToasts } = useToastsContext();

  return $api.useMutation("patch", "/v2/lending/application_applicant_details/{uuid}/consent/", {
    onSuccess: () => {
      clearToasts();
    },
    onError: (error) => {
      showGenericErrorToast();
      Sentry.captureException(error);
    },
  });
}

export { usePatchApplicantConsentQuery };
